/** @format */

import { useTranslation } from 'react-i18next'
import { useAuth } from '@/entities/auth/model'
export const useSidebarController = () => {
  const { t } = useTranslation()
  const { permission } = useAuth()

  // GROUPS
  const userManagement = permission?.[`${t('menu_user_management')}`]
  const dataLibrary = permission?.[`${t('menu_data_library')}`]
  const warehouse = permission?.[`${t('menu_warehouse')}`]
  const supplyDepartment = permission?.[`${t('menu_supply_management')}`]

  const view = {
    // Users management
    users: {
      user: userManagement?.[t('menu_user')]?.VIEW,
      department: userManagement?.[t('menu_department')]?.VIEW,
      position: userManagement?.[t('menu_position')]?.VIEW,
      employee: userManagement?.[t('menu_employee')]?.VIEW,
      requestOrderDescription:
        userManagement?.[t('menu_description_for_request_order')]?.VIEW,
      requestOrderSign:
        userManagement?.[t('menu_signing_for_requesting_order')]?.VIEW,
      requestPermitDescription:
        userManagement?.[t('menu_description_for_request_permit')]?.VIEW,
      requestPermitSign:
        userManagement?.[t('menu_signing_for_request_permit')]?.VIEW,
      requestDescription:
        userManagement?.[t('menu_description_for_request')]?.VIEW,
      unitDescription: userManagement?.[t('menu_description_for_unit')]?.VIEW,
    },
    // DataLibrary
    dataLibrary: {
      roles: dataLibrary?.[t('menu_role')]?.VIEW,
      categories: dataLibrary?.[t('menu_category')]?.VIEW,
      docTypes: dataLibrary?.[t('menu_doc_types')]?.VIEW,
      categoryOrder: dataLibrary?.[t('menu_category_order')]?.VIEW || true,
      materials: dataLibrary?.[t('menu_material')]?.VIEW,
      glassThickness: dataLibrary?.[t('menu_glass_thickness')]?.VIEW,
      measurement: dataLibrary?.[t('menu_measure_unit')]?.VIEW,
      heightLength: dataLibrary?.[t('menu_length_height')]?.VIEW,
      company: dataLibrary?.[t('menu_company')]?.VIEW,
      regions: dataLibrary?.[t('menu_address')]?.VIEW,
      branches: dataLibrary?.[t('branches')]?.VIEW,
      warehouses: dataLibrary?.[t('menu_warehouse')]?.VIEW,
      positions: userManagement?.[t('menu_position')]?.VIEW,
      suppliers: dataLibrary?.[t('suppliers')]?.VIEW,
      customers: dataLibrary?.[t('menu_customer')]?.VIEW,
      employees: userManagement?.[t('menu_employee')]?.VIEW,
      districts: dataLibrary?.[t('menu_address')]?.VIEW || true,
      departments: userManagement?.[t('menu_department')]?.VIEW,
      locations: dataLibrary?.[t('locations')]?.VIEW,
      lables: dataLibrary?.[t('menu_placement_in_warehouse')]?.VIEW,
      inventory: dataLibrary?.[t('menu_inventory')]?.VIEW || true,
      transport: dataLibrary?.[t('menu_transport')]?.VIEW,
    },
    // Warehouse
    warehouse: {
      warehouse: dataLibrary?.[t('menu_warehouse')]?.VIEW,
      request: warehouse?.[t('menu_request')]?.VIEW,
      unitForMaterials: warehouse?.[t('menu_unit_for_material')]?.VIEW,
      stocksManagement: warehouse?.[t('menu_warehouse')]?.VIEW,
      materials: warehouse?.[t('menu_unit_for_material')]?.VIEW || true,
      readyProducts: warehouse?.[t('ready_products')]?.VIEW || true,
      inventory: warehouse?.[t('menu_unit_for_material')]?.VIEW || true,
      requests: warehouse?.[t('menu_request')]?.VIEW,
      lables: dataLibrary?.[t('menu_placement_in_warehouse')]?.VIEW,
    },
    // Supply Department
    supplyDepartment: {
      supplyDepartment: supplyDepartment?.[t('menu_supply_management')]?.VIEW,
      requestOrder: supplyDepartment?.[t('menu_request_order')]?.VIEW,
      requestPermit: supplyDepartment?.[t('menu_request_permit')]?.VIEW,
    },
  }

  const UserView = view.users

  // DataLibrary view
  const DataLibraryView = view.dataLibrary.roles

  const viewEL = {
    [t('/')]: {
      view: true,
    },
    [t('user_management')]: {
      view: UserView || true,
    },
    [t('/data-library')]: {
      view: DataLibraryView || true,

      [t('basic_references')]: {
        view: true,
        [t('/categories')]: { view: view?.dataLibrary?.categories },
        [t('/category-order')]: { view: view?.dataLibrary?.categoryOrder },
        [t('/measurement')]: { view: view?.dataLibrary?.measurement },
        [t('/height-length')]: { view: view?.dataLibrary?.heightLength },
        [t('/glass-thickness')]: { view: view?.dataLibrary?.glassThickness },
        [t('/materials')]: { view: view?.dataLibrary?.materials },
        [t('/equipments')]: { view: view?.dataLibrary?.inventory },
        [t('/doc-types')]: { view: view?.dataLibrary?.docTypes },
      },

      [t('organizational_structure')]: {
        view: true,
        [t('/company')]: { view: view?.dataLibrary?.company },
      },
      [t('contract_partners')]: {
        view: true,

        // [t('/suppliers')]: { view: view?.dataLibrary?.suppliers },
        [t('/customers')]: { view: view?.dataLibrary?.customers },
      },
      [t('user_management')]: {
        view: DataLibraryView || true,
        [t('roles')]: { view: view?.dataLibrary?.roles },
        [t('/positions')]: { view: view?.dataLibrary?.positions },
        [t('/employees')]: { view: view?.dataLibrary?.employees },
      },
      [t('operational_data')]: {
        view: DataLibraryView || true,
        [t('region')]: { view: view?.dataLibrary?.regions },
        [t('branch')]: { view: view?.dataLibrary?.branches },
        [t('warehouse')]: { view: view?.dataLibrary?.warehouses },
        [t('districts')]: { view: view?.dataLibrary?.districts },
        [t('department')]: { view: view?.dataLibrary?.departments },
        [t('locations')]: { view: view?.dataLibrary?.locations },
        [t('lables')]: { view: view?.dataLibrary?.lables },
        [t('transport')]: { view: view?.dataLibrary?.transport },
      },
    },
    [t('warehouse')]: {
      view: view?.warehouse || true,
      [t('stocks-management')]: {
        view: true,
        [t('menu_unit_for_material')]:
          { view: view?.warehouse?.materials || true },
        [t('ready-products')]: { view: view?.warehouse?.readyProducts },
        [t('materials')]: { view: view?.warehouse?.materials },
        [t('inventory')]: { view: view?.warehouse?.inventory },
        [t('requests')]: { view: view?.warehouse?.requests },
        [t('lables')]: { view: view?.warehouse?.lables },
      },
      [t('warehouse')]: { view: view?.warehouse?.warehouse },
      [t('request')]: { view: view?.warehouse?.request },
      [t('unit_for_materials')]: { view: view?.warehouse?.unitForMaterials },
    },
    [t('supply_department')]: {
      view: view?.supplyDepartment || true,
      [t('supply_department')]: {
        view: view?.supplyDepartment?.supplyDepartment,
      },
      [t('request_order')]: { view: view?.supplyDepartment?.requestOrder },
      [t('request_permit')]: { view: view?.supplyDepartment?.requestPermit },
    },
    [t('login')]: { view: true },
  }

  return viewEL
}

